export default __webpack_public_path__ + "static/media/overhead.9e662fb1.svg";